import { useEffect } from 'react';

import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import type { EvaluationStatus, GetSimulationQueryResult } from '@/modules/simulations/types';
import { isEvaluationInProgress } from '@/modules/simulations/utils';

import { FIVE_SECONDS } from './useSimulations';

export const GET_SIMULATION = gql`
  query GetSimulation($sessionId: String!) {
    rows: get_simulation(args: { session_id: $sessionId }) {
      account_id
      session_id
      simulation_run_id
      simulation_evaluation_id
      channel_type
      start_time
      end_time
      num_turns
      brain_id
      brain_parent_id
      brain_version
      turns
    }
  }
`;

export const useSimulationSession = (
  sessionId?: string | null,
  evaluationStatus?: EvaluationStatus
) => {
  const { data, loading, error, startPolling, stopPolling } = useQuery<GetSimulationQueryResult>(
    GET_SIMULATION,
    { variables: { sessionId }, skip: !sessionId }
  );

  const isInProgress = isEvaluationInProgress(evaluationStatus);

  useEffect(() => {
    if (!sessionId || !isInProgress) {
      return undefined;
    }
    startPolling(FIVE_SECONDS);
    return () => stopPolling();
  }, [sessionId, isInProgress, startPolling, stopPolling]);

  return { session: data?.rows?.[0] ?? null, isLoading: loading, error };
};
